import React, { useState, useEffect } from 'react';
import { MessagesSquare } from 'lucide-react';
import { useAdminSession } from '../../context/AdminSessionContext';
import { useAbortableTask } from '../../hooks/useAbortableTask';
import { AdminEmptyState, formatDate } from './AdminShared';

const ConversationPreview = ({ sessionId, copy }) => {
  const { api } = useAdminSession();
  const task = useAbortableTask();
  const [messages, setMessages] = useState([]);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!sessionId) return undefined;
    const operation = task.start(); setMessages([]); setFailed(false);
    api.get(`/chat/${sessionId}/messages`, operation.signal)
      .then(data => { if (task.isCurrent(operation)) setMessages(data); })
      .catch(() => { if (task.isCurrent(operation)) setFailed(true); });
    return task.cancel;
  }, [api, sessionId, task]);
  return <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5 lg:col-span-3" data-testid="admin-conversation-view">
    {!sessionId && <p className="py-16 text-center text-sm text-slate-500">{copy.selectConversation}</p>}
    {failed && <p role="alert" data-testid="admin-conversation-error">{copy.conversationError}</p>}
    <div className="max-h-[520px] overflow-y-auto">{messages.map(item => <div key={item.id} data-testid={`admin-message-${item.id}`} className={`chat-bubble ${item.role}`}>{item.content}</div>)}</div>
  </div>;
};

export const AdminConversations = ({ sessions, copy, lang, onReview }) => {
  const [selected, setSelected] = useState(null);
  const open = session => {
    setSelected(session.session_id);
    onReview({ kind: 'session', id: session.session_id, session_id: session.session_id, title: copy.conversation });
  };
  if (!sessions.length) return <AdminEmptyState icon={MessagesSquare} text={copy.noChats} />;
  return <div className="grid gap-6 lg:grid-cols-5"><div className="space-y-2.5 lg:col-span-2" data-testid="admin-session-list">{sessions.map(session => <button key={session.session_id} data-testid={`admin-session-${session.session_id}`} onClick={() => open(session)} className={`w-full rounded-xl border p-4 text-left ${selected === session.session_id ? 'border-blue-600 bg-blue-50' : 'border-slate-200 bg-white'}`}>
    <div className="flex flex-wrap items-center justify-between gap-2"><span className="text-xs font-mono text-slate-400">{session.session_id.slice(0, 18)}…</span><span className="text-xs text-slate-500">{formatDate(session.last_at, lang)}</span></div>
    <p className="mt-1.5 line-clamp-2 text-sm text-slate-700">{session.preview}</p><span className="mt-1.5 inline-block text-xs font-semibold text-blue-700">{session.message_count} {copy.messages}</span>
  </button>)}</div><ConversationPreview sessionId={selected} copy={copy} /></div>;
};